import { c as _c } from "react/compiler-runtime";
import { Maybe } from '@/utils/types';
import { useTranslation } from 'react-i18next';
interface Props {
  value: Maybe<string>;
}
export function Department(t0) {
  const $ = _c(20);
  const {
    value
  } = t0;
  const {
    t
  } = useTranslation("career");
  switch (value) {
    case "sales":
      {
        let t1;
        if ($[0] !== t) {
          t1 = t("department.sales");
          $[0] = t;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case "hr":
      {
        let t1;
        if ($[2] !== t) {
          t1 = t("department.hr");
          $[2] = t;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case "it":
      {
        let t1;
        if ($[4] !== t) {
          t1 = t("department.it");
          $[4] = t;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    case "marketing":
      {
        let t1;
        if ($[6] !== t) {
          t1 = t("department.marketing");
          $[6] = t;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
    case "product":
      {
        let t1;
        if ($[8] !== t) {
          t1 = t("department.product");
          $[8] = t;
          $[9] = t1;
        } else {
          t1 = $[9];
        }
        return t1;
      }
    case "customer":
      {
        let t1;
        if ($[10] !== t) {
          t1 = t("department.customer");
          $[10] = t;
          $[11] = t1;
        } else {
          t1 = $[11];
        }
        return t1;
      }
    case "finance":
      {
        let t1;
        if ($[12] !== t) {
          t1 = t("department.finance");
          $[12] = t;
          $[13] = t1;
        } else {
          t1 = $[13];
        }
        return t1;
      }
    case "compliance":
      {
        let t1;
        if ($[14] !== t) {
          t1 = t("department.compliance");
          $[14] = t;
          $[15] = t1;
        } else {
          t1 = $[15];
        }
        return t1;
      }
    case "data":
      {
        let t1;
        if ($[16] !== t) {
          t1 = t("department.data");
          $[16] = t;
          $[17] = t1;
        } else {
          t1 = $[17];
        }
        return t1;
      }
    case "legal":
      {
        let t1;
        if ($[18] !== t) {
          t1 = t("department.legal");
          $[18] = t;
          $[19] = t1;
        } else {
          t1 = $[19];
        }
        return t1;
      }
    default:
      {
        return null;
      }
  }
}